/** BRANDUI-1 · 通用设置「对外字段」的小工具：灰色示例（placeholder，不保存、不对外）+ 假号段识别。 */

/** 美国电影 / 文档专用假号段 555-0100 ~ 555-0199：早期版本曾把它当出厂默认值，现网可能还存着。 */
export function isSamplePhone(v: string | null | undefined): boolean {
  return /555[-\s.]?01\d\d/.test(v ?? "");
}

/** 空值时输入框里显示的灰色示例（只是提示，不会被保存，也不会对外显示）。 */
export const BRAND_PLACEHOLDER = {
  name_cn: "例：悠途旅行",
  name_en: "例：UTOUR Travel LLC",
  brand_name: "例：悠途",
  registered_address: "例：123 Main St, Seattle, WA 98101, USA",
  contact_phone: "例：+1 206 555 1234",
  contact_email: "例：info@公司域名",
} as const;

export const MISSING_NOTE = "没填：同行站 / 手机站 / 确认函 / 平台接口里这一项不显示";
export const SAMPLE_PHONE_NOTE = "这是示例号码，请改成真实号码";
